<template>
<div class="" style="padding:70px 0;">


  <div class="row pad">
    
      <div class="col s12 m7m">

       <!--  <h2>Società: la tua posizione attuale</h2> -->
<!-- da sistemare
        <div class="row pad" v-for="item in $teras._si"  :key="item.id" :class="'item_'+item.id" v-if="item.dimesso!=1">
          <div class="col s2 yo-align-left yo-valign-text-center" style="height:50px;">{{item.socsigla}}</div>
          <div class="col s8 yo-valign-text-center" style="height:50px;">{{item.socnome}}</div>
          <div class="col s2 yo-valign-text-center" style="height:50px;" v-if="item.societa==700 && item.dimesso==0">in regola al {{item.ultimoanno}}</div>
          <div class="col s2 yo-valign-text-center" style="height:50px;" v-if="item.dimesso==1">dimesso</div>
        </div> 
        -->
<!-- 
        <div class="row " style="margin-top:30px;" v-if="$teras.app.device!='mobile'">
          <div class="col s12 m3 offset-mm yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-edit" class="white">PROFILO</router-link></div>
          <div class="col s12 m3 offset-m1 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-password" class="white">CREDENZIALI</router-link></div>
          <div class="col s12 m3 offset-m1 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-rinnovo" class="white">RINNOVO</router-link></div> 
          <div class="col s12 m3 offset-m1 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-rinnovo" class="white">ASSICURAZIONE</router-link></div>
        </div>
-->

      <h2>To Assicurazione</h2>

        <div class="row vpad pad">
           <div class="col s6 clear">Codice Prodotto<div class="yo-text-xs">è una stringa alfanumerica che vi verrà comunicata da AON</div></div><div class="col s6">COD_PROD=<span class="crimson">da comunicare</span></div>
           
           <div class="col s6 clear">Data generazione Token<div class="yo-text-s">limita la validità del link a 7 giorni</div></div><div class="col s6">NO</div>
           <div class="col s6 clear">Id Convenzione<div class="yo-text-s">è un intero lungo che vi verrà comunicato da AON</div></div><div class="col s6">ID_CONV=<span class="crimson">da comunicare</span></div>
           <div class="col s6 clear">Nome<div class="yo-text-s">verrà inserito all’intero del questionario assuntivo.</div></div><div class="col s6">NOM_CON={{$socio.contatto.row.nome}}</div>
           <div class="col s6 clear">Cognome<div class="yo-text-s"> verrà inserito all’intero del questionario assuntivo.</div></div><div class="col s6">COG_CON={{$socio.contatto.row.cognome}}</div>
           <div class="col s6 clear">Data di nascita<div class="yo-text-s">verrà inserits all’intero del questionario assuntivo.</div></div><div class="col s6">DAT_NAS_CON={{$socio.contatto.row.natoil | data('DD-MM-YYYY')}}</div>
           <div class="col s6 clear">E Mail<div class="yo-text-s">verrà inserita all’intero del questionario assuntivo e utilizzata nel processo di registrazione automatico al termine del preventivo per mandare la mail con gli estremi di registrazione al cliente.</div></div><div class="col s6">EMAIL_CON={{$socio.contatto.row.email}}</div>
           <div class="col s6 clear">Numero Transazione<div class="yo-text-s">per SIP sarà il codice del socio da restituire sul file di export</div></div><div class="col s6">NUM_TRAN={{$socio.contatto.row.id}}</div>
           <div class="col s6 clear">Descrizione Transazione<div class="yo-text-s">codice numerico della transazione</div></div><div class="col s6">NO</div>

           <div class="col s6 clear">AES encryption</div><div class="col s6">MODE=ECB | KEY SIZE=128 | FORMAT=base64</div>
           <div class="col s6 clear">Chiave di criptazione</div><div class="col s6"><span class="crimson">{{key}}</span></div>
           <div class="col s6 clear">Link base</div><div class="col s6">https://www.sip.aon.it/it/landing_page?token=</div>
          
        </div>

      <h2>From Assicurazione</h2>

        <div class="row vpad pad">

          <div class="col s2">Export</div><div class="col s10">Il file di export per SIP conterrà oltre ai campi richiesti dalla segreteria in aggiunta anche il Numero transazione che inviamo in fase di collegamento con la piattaforma AON</div>
          <div class="col s2">Univocità</div><div class="col s10">i record presenti nei vari files saranno sempre univoci in quanto vengono esportati da AON una volta che il pagamento è stato riconciliato</div>
          <div class="col s2">Formato</div><div class="col s10">file csv con separatore |</div>
          <div class="col s2">Timing</div><div class="col s10">giornaliero ore 00:30</div>
          <div class="col s2">File esempio</div><div class="col s10"><span class="crimson">in attesa da AON</span></div>

        </div>

      </div>

      <div class="col s12 m4m">
        <contattoSide></contattoSide>

        <br />

        <div class="row row-head">
          <div class="col s12">FTP over TLS</div>
        </div>
        <div class="row vpad pad-in row-table-firstcol">
          <div class="col s4 yo-height-full">URL</div>
          <div class="col s8">www.terasmm.it</div>


          <div class="col s4 yo-height-full">CRYPTAZIONE</div>
          <div class="col s8">FTP su TLS</div>

          <div class="col s4 yo-height-full">USERNAME</div>
          <div class="col s8">aonftp</div>

          <div class="col s4 yo-height-full">PASSWORD</div>
          <div class="col s8">@$$1cur@$1p</div>
        </div>

      </div>

    </div>

    <div class="row" style="margin-top:16px;">
          <!--
          <div class="col s1 clear yo-text-xs">TOKEN DATA</div><div class="col s11 yo-text-xs">{{token}}</div>
          <div class="col s1 clear yo-text-xs">TOKEN AES</div><div class="col s11 yo-text-xs">{{tokenAES}}</div>
          -->
          <div class="col s1 clear yo-text-xs">TOKEN</div><div class="col s11 yo-text-xs">{{tokenURI}}</div>
          <!--
          <div class="col s1 clear yo-text-xs">TOKEN URI </div><div class="col s11 yo-text-xs">CQxyzrwweeNycHDUFRQ9ylDXf4EDwyCYaHfQFnPyP4vYrn4%2FGh9wXZmQUFrjZwbXT0n8F6srNY8XKVpQGDppruEVTGYVkka6soscV5Na4fZkOzB%2FD8SUK7ho%2Be%2BlHsxD%2FJOWTKzkB2%2BWCtodT7BgNz17LFsh2YVETbcwm5V5331xHwouSX14RBcES7t6AwpWePaKNA8xayVGvfK7a4Hlnw%3D%3D</div>
          -->
    </div>


</div>
</template>

<script>
import contattoSide from './Contatto-side.vue'
import aes from '../teras/aes'

export default {
   name: 'home'
   ,components: {
    contattoSide
  }
  ,data () {
    return {
      key:'X40RFfFuZYckb2Vu',
      codProd:'da comunicare',
      idConv:'da comunicare',
      password:''
    }
  }
  ,created () {
    aes.password = aes.convertCryptKey(this.key)
  }
  ,computed: {
      token: function () {
         var params = []
        params.push('COD_PROD='+this.codProd)
        params.push('ID_CONV='+this.idConv)
        params.push('NOM_CON='+this.$socio.contatto.row.nome)
        params.push('COG_CON='+this.$socio.contatto.row.cognome)
        params.push('DAT_NAS_CON='+this.$teras.data(this.$socio.contatto.row.natoil,'DD-MM-YYYY'))
        params.push('EMAIL_CON='+this.$socio.contatto.row.email)
        params.push('NUM_TRAN='+this.$socio.contatto.row.id)
        params.push('DESCR_TRAN='+this.$socio.contatto.row.codicefiscale)

        return params.join('|')
      }
      ,tokenAES: function () {
        return aes.encode64(this.token)
      }
      ,tokenURI: function (){
        return encodeURIComponent(this.tokenAES)
      }
   }
   
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}

</style>
